export default "__VITE_ASSET__BJBaP0KS__"